<script setup lang="ts">
    import Button from '@/shared/ui/Button/Button.vue';
    import { DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/shared/ui/Dialog';
    import InputField from '@/shared/components/form-fields/InputField/InputField.vue';
    import { useAuthDialogStore } from '../auth-dialog-store';
    import { Form } from 'vee-validate';

    const store = useAuthDialogStore();
    const isLoading = ref(false);
    const { t } = useI18n();

    async function handleSubmit() {
        isLoading.value = true;
        if (await store.sendPasswordResetLink()) store.modalState = 'password-reset-sent';
        isLoading.value = false;
    }
</script>

<template>
    <Form @submit="handleSubmit">
        <DialogHeader>
            <DialogTitle>{{ $t('USER.FORGOT_PASSWORD') }}</DialogTitle>
            <DialogDescription class="sr-only">{{ t('DESCRIPTION') }}</DialogDescription>
        </DialogHeader>
        <div class="my-4 space-y-4">
            <InputField
                v-model="store.resetPasswordEmail"
                name="email"
                :label="$t('USER.EMAIL')"
                :placeholder="$t('USER.EMAIL')"
                rules="required|email"
            />
        </div>
        <DialogFooter>
            <Button
                variant="secondary"
                type="button"
                @click="store.modalState = 'login'"
            >
                {{ t('BACK') }}
            </Button>
            <Button
                variant="brand"
                type="submit"
                :disabled="isLoading"
                :loading="isLoading"
            >
                {{ $t('GLOBAL.CONFIRM') }}
            </Button>
        </DialogFooter>
    </Form>
</template>

<i18n lang="yaml">
en:
    BACK: Back
    DESCRIPTION: Send password reset link to provided email
nl:
    BACK: Terug
    DESCRIPTION: Stuur de link voor het opnieuw instellen van uw wachtwoord naar het opgegeven e-mailadres.
</i18n>
